import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useCreateDesignationMutation, useGetDesignationDataQuery, useUpdateDesignationMutation } from "store/services/designations";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { Formik } from "formik";
import designationFormSchema from "./DesignationForm.schema";
import { DESIGNATIONS_LIST } from "config/paths";
import LoadingButton from "components/shared/LoadingButton";
import { successMessageToast } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";

// css
import styles from "./addForm.module.scss";
import { RequiredFieldAstrick } from "components/Common/Common";


const AddDesignation = () => {
  const { id: designationId } = useParams();
  const editMode = !!designationId;
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    status: "active"
  });

  const { data: designationData, isLoading: getDesignationLoading, isError: getDesignationError } = useGetDesignationDataQuery(designationId, { skip: !designationId });
  const [createDesignation, { isLoading }] = useCreateDesignationMutation();
  const [updateDesignation, { isLoading: updateDesignationLoading }] = useUpdateDesignationMutation();

  useEffect(() => {
    if (!designationData) {
      return;
    }
    setInitialValues(prevState => ({
      ...prevState,
      title: designationData?.title,
      description: designationData?.description,
      status: designationData?.status
    }))
  }, [designationData]);

  const handleSubmit = async (payload) => {
    try {
      let result;
      if (editMode) {
        result = await updateDesignation({
          id: designationId,
          payload
        });
      } else {
        result = await createDesignation(payload);
      }

      if (result.error) {
        console.error("Error creating Designation", result.error);
      } else {
        successMessageToast(result?.data?.message || "Designation created successfully");
        navigate(DESIGNATIONS_LIST);
      }
    } catch (err) {
      console.log("Error creating Designation", err);
    }
  }

  const handleClickCancel = () => {
    navigate(DESIGNATIONS_LIST);
  }

  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3 d-flex align-items-center">
                <Link
                  className="themeBlue fw-sbold back-to-btn"
                  to={DESIGNATIONS_LIST}
                >
                  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                  </svg> Back
                </Link>
                <h6 className="m-0 fw-bold themeBlue">
                  Create New Designations
                </h6>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              {getDesignationLoading ? (
                <LoadingIndicator />
              ) : getDesignationError ? (
                <ErrorComponent />
              ) : (
                <Formik
                  initialValues={initialValues}
                  validationSchema={designationFormSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({
                    handleSubmit
                  }) => (
                    <Form onSubmit={handleSubmit}>
                      <div
                        className="py-3"
                        style={{ borderTop: "1px solid #41a2a84d" }}
                      >
                        <Row>
                          <Col md="4" sm="6" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0 d-flex"
                            >
                              Designations Title
                              <RequiredFieldAstrick />
                            </label>
                            <AppInputField
                              type="text"
                              name="title"
                              placeholder="Designation title here"
                              className={`${styles.formControl} form-control`}
                            />
                          </Col>
                          <Col md="10" sm="8" className="my-2">
                            <label
                              htmlFor=""
                              className="form-label themeBlue fw-bold mb-0 d-flex"
                            >
                              Description
                              <RequiredFieldAstrick />
                            </label>
                            <AppInputField
                              rows="8"
                              name="description"
                              type="text"
                              fieldType={"textarea"}
                              placeholder="Please Add Description"
                              className={`${styles.formControl} form-control h-auto`}
                            />
                          </Col>
                        </Row>
                      </div>
                      <Row className="mt-4">
                        <Col className="my-2" lg="12">
                          <div
                            className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                            style={{ borderTop: "1px solid #41a2a84d" }}
                          >
                            <LoadingButton
                              type="submit"
                              className="d-flex align-items-center justify-content-center commonBtn"
                              isLoading={isLoading || updateDesignationLoading}
                            >
                              Save
                            </LoadingButton>
                            <Button
                              className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
                              onClick={handleClickCancel}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddDesignation;
